<template>
  <div class="config">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="12">
          <div class="card card-custom">
            <div class="card-header">
              <div class="card-title">
                <h3 class="card-label">Payment Form Configuration</h3>
              </div>
              <div class="header-aside-content">
                <div class="aside-btn w-200">
                  <v-select
                    :items="paymentModes"
                    item-text="name"
                    item-value="paymentModeId"
                    v-model="selectedPaymentMode"
                    @change="getPaymentForm"
                    dense
                    label="Payment Modes"
                    outlined
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <v-data-table
                :headers="configHeader"
                :items="paymentConfigList"
     
                hide-default-footer
                class="elevation-1"
              >
              
                <template v-slot:item.inputValue="{ item }">
                  <v-text-field
                    label="value"
                    
                  ></v-text-field>
                </template>
                <template v-slot:item.editableByCustomer="{ item }">
                  <div class="table-checkbox">
                      <v-checkbox                      
                          label=""
                          color="primary"
                          value="true"
                          hide-details
                        ></v-checkbox>
                  </div>
                </template>

                <template v-slot:item.status="{ item }">
                  <span class="table-btn" :class="item.status">{{ item.status}}</span>
                </template>
                
              </v-data-table>
              <!-- <v-simple-table height="300px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Key
                      </th>
                      <th class="text-left">
                        Input Value
                      </th>
                      <th class="text-left">
                        Is Editable
                      </th>
                      <th class="text-left">
                        Default
                      </th>
                      <th class="text-left">
                        Has Default
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in config" :key="item.name">
                      <td>{{ item.key }}</td>
                      <td>
                        <v-select
                          :items="configType"
                          outlined
                          dense
                          v-model="item.type"
                        ></v-select>
                      </td>
                      <td>
                        <v-btn depressed color="blue lighten-2" height="35px">
                          True
                        </v-btn>
                      </td>
                      <td>{{ item.default }}</td>
                      <td>
                        <v-checkbox v-model="item.hasDefault"></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table> -->
            </div>
            <div class="card-body pt-2">
              <div class="btn-wrapper btn-aside-right">
                
                <v-btn depressed class="custom-secondary-btn">
                  Cancel
                </v-btn>
                <v-btn depressed color="primary">
                  Submit
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Promise from "../../../../lib/mixins/ExtendedPromises";
import Config from "../../../../repositories/adminPaymentFormKeyController.js";
import AdminPayment from "../../../../repositories/adminPaymentModeController";
export default {
  name: "Config",
  mixins: [Promise],
  data() {
    return {
      paymentModes: [],
      selectedPaymentMode: "",
      paymentConfigList: [],
      configHeader: [ ],
      configType: ["text", "number"],
      config: [
        {
          key: "Full Name",
          type: "text",
          isRequired: true,
          default: "Enabled",
          hasDefault: true
        },
        {
          key: "Phone",
          type: "text",
          isRequired: true,
          default: "Enabled",
          hasDefault: true
        },
        {
          key: "Email",
          type: "text",
          isRequired: true,
          default: "Enabled",
          hasDefault: false
        },
        {
          key: "Address",
          type: "text",
          isRequired: true,
          default: "Enabled",
          hasDefault: false
        }
      ]
    };
  },
  mounted() {
    this.getPaymentModes();
    this.setTableHeader();
  },
  methods: {
    setTableHeader() {
      this.configHeader= [
          {
            text: 'Column Name',
            align: 'start',
            value: 'columnName',
          },
          { text: 'Mode', value: 'paymentMode' },
          { text: 'Input Type', value: 'inputType' },
          { text: 'Input value', value: 'inputValue' },
          { text: 'Editable By Customer', value: 'editableByCustomer' },
          { text: 'Status', value: 'status' },
        ]
    },
    getPaymentModes() {
      const operation = this.response(AdminPayment.getAllPaymentModes());
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.paymentModes = response.data;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    getPaymentForm() {
      const operation = this.response(
        Config.getAllPaymentFormKeys(this.selectedPaymentMode)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.paymentConfigList = response.data;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    }
  }
};
</script>
